var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "product-selector", class: { vertical: _vm.vertical } },
        _vm._l(_vm.productList, function(product, idx) {
          return _c("product-avatar", {
            key: idx,
            attrs: {
              product: product,
              selected: _vm.isSelected(product),
              clickable: "",
              vertical: _vm.vertical
            },
            on: {
              click: function($event) {
                return _vm.selectProduct(product)
              }
            }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }